<mat-form-field appearance="outline" class="si-chips-field">
    <mat-label>{{ 'MENU.SPECIAL_INSTRUCTIONS.IGNORE_SECTION' | translate }}</mat-label>

    <mat-chip-list #chipList>
        <mat-chip *ngFor="let chip of chips; trackBy: trackById"
                  [class.si-chip-unknown]="isUnknown(chip)"
                  [matTooltip]="isUnknown(chip) ? ('MENU.SPECIAL_INSTRUCTIONS.UNKNOWN_ID_HINT' | translate) : chip.hint"
                  (removed)="remove(chip.id)">
            <mat-icon class="si-unknown-icon" *ngIf="isUnknown(chip)">warning</mat-icon>
            {{ chip.label }}
            <button matChipRemove type="button">
                <mat-icon>cancel</mat-icon>
            </button>
        </mat-chip>

        <input #searchInput
               [matChipInputFor]="chipList"
               [matAutocomplete]="auto"
               [matChipInputAddOnBlur]="false"
               [placeholder]="'MENU.SPECIAL_INSTRUCTIONS.SEARCH_HINT' | translate"
               [(ngModel)]="search"
               [ngModelOptions]="{standalone: true}"
               (ngModelChange)="onSearchChange()"
               (matChipInputTokenEnd)="onTokenEnd($event.value)">
    </mat-chip-list>

    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onOptionSelected($event.option.value)">
        <mat-option *ngFor="let option of visibleOptions; trackBy: trackById" [value]="option.id">
            <span class="si-option-label">{{ option.label }}</span>
            <span class="si-option-hint">{{ option.hint }}</span>
        </mat-option>

        <mat-option *ngIf="hiddenOptionsCount > 0" disabled>
            <span class="si-option-hint">
                {{ 'MENU.SPECIAL_INSTRUCTIONS.MORE_OPTIONS' | translate: {count: hiddenOptionsCount} }}
            </span>
        </mat-option>
    </mat-autocomplete>
</mat-form-field>
